<template>
  <div>
    <v-card class="app-card"
            v-bind:rounded="$vuetify.breakpoint.mdAndDown ? null : 'lg'"
            v-bind:tile="$vuetify.breakpoint.mdAndDown"
            v-if="loading">
      <v-skeleton-loader type="list-item-avatar-two-line@8" />
    </v-card>
    <v-card class="app-card"
            v-bind:rounded="$vuetify.breakpoint.mdAndDown ? null : 'lg'"
            v-bind:tile="$vuetify.breakpoint.mdAndDown"
            v-else>
      <v-text-field clearable
                    flat
                    hide-details="auto"
                    prepend-inner-icon="mdi-magnify"
                    solo
                    v-bind:label="$t('search')"
                    v-model="search" />
      <v-divider />
      <div class="empty-state"
           v-if="spotGroups.length === 0">
        <v-icon class="mb-2"
                large>
          mdi-map-marker-off-outline
        </v-icon>
        <p class="mb-0">{{ search ? $t('noResults', { search }) : $t('noEntries') }}</p>
      </div>
      <v-list class="py-0">
        <template v-for="(group, index) of spotGroups">
          <v-subheader class="font-weight-bold"
                       inset
                       v-bind:key="`group-${index}-subheader`">
            {{ group.title }}
          </v-subheader>

          <template v-for="(spot, index) in group.spots">
            <v-list-item exact
                         v-bind:key="`${spot.id}-list_item`"
                         v-on:click="$emit('spot-selected', spot.id )">
              <v-list-item-avatar color="accent">
                <v-icon dark>mdi-fire</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ spot.title }}</v-list-item-title>
                <v-list-item-subtitle>{{ spot.description }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon class="align-self-center ml-2">
                <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-divider inset
                       v-bind:key="`${spot.id}-divider`"
                       v-if="index !== group.spots.length - 1" />
          </template>

          <v-divider v-bind:key="`group-${index}-divider`"
                     v-if="index !== spotGroups.length - 1" />
        </template>
      </v-list>
    </v-card>
  </div>
</template>

<script>
  import moment from 'moment'

  import { mapGetters } from 'vuex'

  export default {
    computed: {
      spotGroups() {
        // Filter spots based on search
        const filteredSpots = this.search
          ? this.spots.filter(spot => 
          spot.title?.toLowerCase().includes(this.search.toLowerCase()) ||
          spot.description?.toLowerCase().includes(this.search.toLowerCase())
        )
          : this.spots

        // Group by first letter
        const groups = filteredSpots.reduce((result, spot) => {
          // Remove "Foodspot" prefix (case-insensitive) and get first letter of next word
          const titleWithoutPrefix = spot.title?.replace(/^foodspot\s+/i, '') || ''
          const firstLetter = (titleWithoutPrefix[0] || '#').toUpperCase()
          const letter = /[A-Z]/.test(firstLetter) ? firstLetter : '#'
          
          const existing = result.find(g => g.title === letter)
          if (existing) {
        existing.spots.push(spot)
          } else {
        result.push({
          title: letter,
          spots: [spot]
        })
          }
          
          return result
        }, [])

        // Sort groups alphabetically, with # at the end
        return groups.sort((a, b) => {
          if (a.title === '#') return 1
          if (b.title === '#') return -1
          return a.title.localeCompare(b.title)
        })
      },
      ...mapGetters([
        'attachmentUrl',
        'categoryTitle'
      ])
    },
    data: () => ({
      search: null
    }),
    methods: {

    },
    name: 'SpotListCard',
    props: {
      loading: Boolean,
      spots: Array
    }
  }
</script>

<i18n>
  {
    "de": {
      "noEntries": "Noch keine Einträge vorhanden.",
      "noResults": "Keine Treffer für „{search}“.",
      "search": "Suche"
    },
    "en": {
      "noEntries": "No entries yet.",
      "noResults": "No results for “{search}”.",
      "search": "Search"
    }
  }
</i18n>